const colorAxis = {
  dataClasses: [
    {
      to: 0,
      color: '#6D6F70',
      name: 'No Data',
    },
    {
      from: 0.0000000001,
      to: 1,
      color: '#218371',
      plotBorderColor: '#FFFFFF',
      borderWidth: 1,
      name: 'Minimal',
    },
    {
      from: 1.0000000001,
      to: 2,
       color: '#6CB2A2',
      plotBorderColor: '#15A796',
      borderWidth: 1,
      name: 'Low',
    },
    {
      from: 2.0000000001,
      to: 3,
    
      color: '#C6E8DF',
      plotBorderColor: '#15A796',
      borderWidth: 1,
      name: 'Moderate',
    },
    {
      from: 3.0000000001,
      to: 4,
      color: '#FFFFF0',
      plotBorderColor: '#AD8D01',
      borderWidth: 1,
      name: 'Moderate',
    },
    {
      from: 4.0000000001,
      to: 5,
       color: '#FEC8B9',
      plotBorderColor: '#FF1A1A',
      borderWidth: 1,
      name: 'High',
    },
    {
      from: 5.0000000001,
      to: 6,
       color: '#F3927E',
      plotBorderColor: '#FF1A1A',
      borderWidth: 1,
      name: 'High',
    },
    {
      from: 6.0000000001,
      to: 7,
       color: '#D7452E',
      plotBorderColor: '#FFFFFF',
      borderWidth: 1,
      name: 'Very High',
    },
    {
      from: 7.0000000001,
      to: 8,
      color: '#C40000',
      plotBorderColor: '#FFFFFF',
      borderWidth: 1,
      name: 'Very High',
    },
  ],
}
export default colorAxis